import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import Svg from '../Svg'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function SurveyListSidebar() {
    //States
    const [isVisibleSubmenu, setIsVisibleSubmenu] = useState(false)
    const { survey_id } = useSelector((state) => state.permissionsData)
    const { pathname } = useLocation()
    const [M1View, setM1View] = useState(0);
    const [M2View, setM2View] = useState(0);
    const [M7ViewOwn, setM7ViewOwn] = useState(0);
    const [M11View, setM11View] = useState(0);
    const [M12View, setM12View] = useState(0);
    const [M13View, setM13View] = useState(0);
    const [M14View, setM14View] = useState(0);
    const [M15View, setM15View] = useState(0);
    const [M16View, setM16View] = useState(0);
    const [M17View, setM17View] = useState(0);
    const [M18View, setM18View] = useState(0);
    const [M19View, setM19View] = useState(0);
    const [M20View, setM20View] = useState(0);
    const [M21View, setM21View] = useState(0);
    const [M22View, setM22View] = useState(0);
    const [M23View, setM23View] = useState(0);

    const { t } = useTranslation();

    const { userData, userFlag } = useSelector((state) => state.userDataHeader)
    useEffect(() => {
        if (userFlag == true) {
            userData.forEach(element => {
                let mp = JSON.parse(element.module_permissions)
                window.modulePermissions.M1.view = (mp?.M1?.view == 1) ? 1 : window.modulePermissions.M1.view;
                window.modulePermissions.M1.add = (mp?.M1?.add == 1) ? 1 : window.modulePermissions.M1.add;
                window.modulePermissions.M1.edit = (mp?.M1?.edit == 1) ? 1 : window.modulePermissions.M1.edit;
                window.modulePermissions.M1.del = (mp?.M1?.del == 1) ? 1 : window.modulePermissions.M1.del;
                window.modulePermissions.M2.view = (mp?.M2?.view == 1) ? 1 : window.modulePermissions.M2.view;
                window.modulePermissions.M3.view = (mp?.M3?.view == 1) ? 1 : window.modulePermissions.M3.view;
                window.modulePermissions.M3.add = (mp?.M3?.add == 1) ? 1 : window.modulePermissions.M3.add;
                window.modulePermissions.M3.edit = (mp?.M3?.edit == 1) ? 1 : window.modulePermissions.M3.edit;
                window.modulePermissions.M3.del = (mp?.M3?.del == 1) ? 1 : window.modulePermissions.M3.del;
                window.modulePermissions.M4.view = (mp?.M4?.view == 1) ? 1 : window.modulePermissions.M4.view;
                window.modulePermissions.M4.add = (mp?.M4?.add == 1) ? 1 : window.modulePermissions.M4.add;
                window.modulePermissions.M4.edit = (mp?.M4?.edit == 1) ? 1 : window.modulePermissions.M4.edit;
                window.modulePermissions.M4.del = (mp?.M4?.del == 1) ? 1 : window.modulePermissions.M4.del;
                window.modulePermissions.M5.view = (mp?.M5?.view == 1) ? 1 : window.modulePermissions.M5.view;
                window.modulePermissions.M5.add = (mp?.M5?.add == 1) ? 1 : window.modulePermissions.M5.add;
                window.modulePermissions.M5.edit = (mp?.M5?.edit == 1) ? 1 : window.modulePermissions.M5.edit;
                window.modulePermissions.M5.del = (mp?.M5?.del == 1) ? 1 : window.modulePermissions.M5.del;
                window.modulePermissions.M6.view = (mp?.M6?.view == 1) ? 1 : window.modulePermissions.M6.view;
                window.modulePermissions.M6.add = (mp?.M6?.add == 1) ? 1 : window.modulePermissions.M6.add;
                window.modulePermissions.M6.edit = (mp?.M6?.edit == 1) ? 1 : window.modulePermissions.M6.edit;
                window.modulePermissions.M6.del = (mp?.M6?.del == 1) ? 1 : window.modulePermissions.M6.del;
                window.modulePermissions.M7.view_own = (mp?.M7?.view_own == 1) ? 1 : window.modulePermissions.M7.view_own;
                window.modulePermissions.M7.view_all = (mp?.M7?.view_all == 1) ? 1 : window.modulePermissions.M7.view_all;
                window.modulePermissions.M7.comment = (mp?.M7?.comment == 1) ? 1 : window.modulePermissions.M7.comment;
                window.modulePermissions.M8.view = (mp?.M8?.view == 1) ? 1 : window.modulePermissions.M8.view;
                window.modulePermissions.M8.add = (mp?.M8?.add == 1) ? 1 : window.modulePermissions.M8.add;
                window.modulePermissions.M8.edit = (mp?.M8?.edit == 1) ? 1 : window.modulePermissions.M8.edit;
                window.modulePermissions.M8.del = (mp?.M8?.del == 1) ? 1 : window.modulePermissions.M8.del;
                window.modulePermissions.M9.view = (mp?.M9?.view == 1) ? 1 : window.modulePermissions.M9.view;
                window.modulePermissions.M9.add = (mp?.M9?.add == 1) ? 1 : window.modulePermissions.M9.add;
                window.modulePermissions.M9.edit = (mp?.M9?.edit == 1) ? 1 : window.modulePermissions.M9.edit;
                window.modulePermissions.M9.del = (mp?.M9?.del == 1) ? 1 : window.modulePermissions.M9.del;
                window.modulePermissions.M10.view = (mp?.M10?.view == 1) ? 1 : window.modulePermissions.M10.view;
                window.modulePermissions.M10.add = (mp?.M10?.add == 1) ? 1 : window.modulePermissions.M10.add;
                window.modulePermissions.M10.edit = (mp?.M10?.edit == 1) ? 1 : window.modulePermissions.M10.edit;
                window.modulePermissions.M10.del = (mp?.M10?.del == 1) ? 1 : window.modulePermissions.M10.del;
                for (let i = 11; i <= 23; i++) {
                    const key = `M${i}`;
                    if (mp?.[key]) {
                        ['view', 'add', 'edit', 'del'].forEach(perm => {
                            window.modulePermissions[key][perm] = (mp[key][perm] == 1) ? 1 : window.modulePermissions[key][perm];
                        });
                    }
                }

            });
            setM1View(window.modulePermissions.M1.view)
            setM2View(window.modulePermissions.M2.view)
            setM7ViewOwn(window.modulePermissions.M7.view_own)
            setM11View(window.modulePermissions.M11.view)
            setM12View(window.modulePermissions.M12.view)
            setM13View(window.modulePermissions.M13.view)
            setM14View(window.modulePermissions.M14.view)
            setM15View(window.modulePermissions.M15.view)
            setM16View(window.modulePermissions.M16.view)
            setM17View(window.modulePermissions.M17.view)
            setM18View(window.modulePermissions.M18.view)
            setM19View(window.modulePermissions.M19.view)
            setM20View(window.modulePermissions.M20.view)
            setM21View(window.modulePermissions.M21.view)
            setM22View(window.modulePermissions.M22.view)
            setM23View(window.modulePermissions.M23.view)

        }
    }, [userFlag])

    //Effects
    useEffect(() => {
        if (survey_id) {
            setIsVisibleSubmenu(true)
        }
    }, [survey_id])

    return (
        <>
            <div className="dashboard-side-menu-wrapper d-flex flex-column align-items-stretch">
                <nav className="dashboard-side-menu position-static">
                    <ul className='top-menu'>
                        {/* <li>
                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/survey/list">
                                <Svg name="dashboard" />
                                <span className="nav-text">
                                    Dashboard
                                </span>
                            </NavLink>
                        </li> */}
                        {M1View == 1 && (
                            <li className="has-subnav">
                                <div className="d-flex drop-wrap align-items-center"> {/*Add Class Active once menu is active*/}
                                    <NavLink className={({ isActive }) => ((isActive || pathname === '/admin/survey/create/start' || (survey_id && isVisibleSubmenu)) ? "active" : 'null')} to="/admin/survey/list">
                                        <Svg name="survey" />
                                        <span className="nav-text">
                                            {t('survey.title')}
                                        </span>
                                    </NavLink>
                                    {survey_id && <button className={`${survey_id && isVisibleSubmenu ? 'drop-btn' : 'drop-btn collapsed'}`} type="button" aria-expanded="false" aria-controls="collapseMenu" onClick={() => setIsVisibleSubmenu(!isVisibleSubmenu)}>
                                        <svg width={24} height={26} viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.07992 15.9941L10.5999 9.31544C11.3699 8.5267 12.6299 8.5267 13.3999 9.31544L19.9199 15.9941" stroke="#0F2744" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>}
                                </div>
                                <div className={`collapse ${survey_id && isVisibleSubmenu ? 'show' : ''}`} id="collapseMenu">
                                    <ul className={`subnav`}>
                                        {M11View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{t('survey.question.title')}</NavLink>
                                        </li>
                                        )}
                                        {M12View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/form-builder?survey_id=${survey_id}`}>{t('survey.builder.title')}</NavLink>
                                        </li>
                                        )}
                                        {M13View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => ((isActive || pathname === '/admin/survey/report/templates') ? "active" : 'null')} to={`/admin/survey/report/builder?survey_id=${survey_id}`}>{t('survey.report.title1')}</NavLink>
                                        </li>
                                        )}
                                        {M14View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/email-template?survey_id=${survey_id}`}>{t('survey.sidebar.email_templates')}</NavLink>
                                        </li>
                                        )}
                                        {M15View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`}>{t('survey.variable.heading')}</NavLink>
                                        </li>
                                        )}
                                        {M16View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/share?survey_id=${survey_id}`}>{t('survey.share.tittle')}</NavLink>
                                        </li>
                                        )}
                                        {M17View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/integrations?survey_id=${survey_id}`}>{t('settings.integration.tittle')}</NavLink>
                                        </li>
                                        )}
                                        {M18View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/webhooks?survey_id=${survey_id}`}>{t('survey.sidebar.webhooks')}</NavLink>
                                        </li>
                                        )}
                                        {M19View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/privacy-policy-new?survey_id=${survey_id}`}>{t("privacyPolicy.heading")}</NavLink>
                                        </li>
                                        )}
                                        {M20View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/cookie-policy?survey_id=${survey_id}`}>{t('survey.sidebar.cookie_policy')}</NavLink>
                                        </li>
                                        )}
                                        {M21View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/questionaire?survey_id=${survey_id}`}>{t('settings.questionnaire.title')}</NavLink>
                                        </li>
                                        )}
                                        {M22View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/thank-you-pages?survey_id=${survey_id}`}>{t('settings.thankyouPage.title')}</NavLink>
                                        </li>
                                        )}
                                        {M23View == 1 && (
                                        <li>
                                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to={`/admin/survey/lead-erasure-rules?survey_id=${survey_id}`}>{t('survey.leadErasure.title')}</NavLink>
                                        </li>
                                        )}
                                    </ul>
                                </div>
                            </li>
                        )}
                        {M2View == 1 && (
                            <li>
                                <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/analytics">
                                    <Svg name="analytics" />
                                    <span className="nav-text">
                                        {t('analytics.title')}
                                    </span>
                                </NavLink>
                            </li>
                        )}
                        <li>
                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/settings/profile">
                                <Svg name="settings" />
                                <span className="nav-text">
                                    {t('settings.title')}
                                </span>
                            </NavLink>
                        </li>
                        {/* <li>
                            <NavLink className={({ isActive }) => (isActive ? "" : 'null')} to="">
                                <Svg name="help" />
                                <span className="nav-text">
                                    Help
                                </span>
                            </NavLink>
                        </li> */}
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/ducumentation/surveys/document-dashboard">
                                <Svg name="survey" />
                                <span className="nav-text">
                                {t('documentation.title')}
                                </span>
                            </NavLink>
                        </li>
                        {M7ViewOwn == 1 && (
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/tickets">
                                <Svg name="survey" />
                                <span className="nav-text">
                                    {t('tickets.title')}
                                </span>
                            </NavLink>
                          </li>
                        )}
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? "active" : 'null')} to="/admin/activity-logs">
                                <Svg name="survey" />
                                <span className="nav-text">
                              {t("activityLog.title")}
                                </span>
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    )
}